import React from 'react';
import classnames from 'classnames';
import Layout from 'sections/Layout';

import Hero from 'sections/TemplatePost/Hero';
import Content from 'sections/TemplatePost/Content';
import Rating from 'sections/common/Rating';
import Share from 'sections/ResourceCenterPost/Share';
import MoreStoriesSec from 'sections/common/MoreStoriesSec';
import ScreverInActionSec from 'sections/common/ScreverInAction';
// TODO: включить после реализации функционала рассылки
// import Subscribe from 'components/Forms/SubscribeForm';

import useAllTemplatesPosts from 'hooks/graphql/useAllTemplatesPosts';
// TODO: отключил по запросу наташи
// import useOptions from 'hooks/graphql/useOptions';
import { TEMPLATES_PAGE } from 'constants/urls';

import * as styles from 'styles/pages/template-post.module.scss';

const TemplatePost = ({ templatePost, ...props }) => {
  const allTemplatesPosts = useAllTemplatesPosts();
  // TODO: отключил по запросу наташи
  // const options = useOptions();

  const {
    content,
    databaseId,
    slug,
    title,
    excerpt,
    tags,
    id,
    language,
    template,
    uri,
    // template: {
    //   templateInnerPost: {
    //     templatePageInActionForm,
    //     templatePageCustomTitleForArticle,
    //   },
    // },
    seo,
  } = templatePost;

  const postType =
    template.templateName === 'Template Inner'
      ? 'templateInnerPost'
      : 'templateLeadGenerator';

  const templatePageInActionForm =
    template?.[postType]?.templatePageInActionForm;
  const templatePageCustomTitleForArticle =
    template?.[postType]?.templatePageCustomTitleForArticle;

  const currentPostСategory = tags.nodes[0]?.name;

  const additionalLink = {
    text: 'More Content',
    url: TEMPLATES_PAGE,
  };

  // TODO: включить после реализации функционала рассылки
  // const subscribeData = {
  //   subscribeFormTitle: 'Get your copy of the guide here!',
  //   subscribeForm: {
  //     subscribeFormInputLabel: 'you’ll receive it as a pdf file',
  //     subscribeFormButtonTitle: 'Get the guide',
  //   },
  // };

  // TODO: отключил по запросу наташи
  // const {
  //   resourceCenterPostInfoTrial: {
  //     resourceCenterPostInfoTrialTitle,
  //     resourceCenterPostInfoTrialUrl,
  //     resourceCenterPostInfoTrialMarketedText,
  //   },
  // } = options.resourceCenterPostInfo.resourceCenterPostInfo;

  const contentHead = {
    title: templatePageCustomTitleForArticle ?? title,
    excerpt: excerpt,
  };

  const moreStories = allTemplatesPosts.filter(
    (stories) => stories.language.slug === language.slug
  );

  const pageUrl = seo.canonical || uri;

  return (
    <Layout
      seo={seo}
      headerDarkColor={true}
      headerWhiteBg={true}
      requestButtonBlue={true}
      // ogImage={sourceUrl}
    >
      {(commonData) => (
        <>
          <div>
            <Hero
              tags={tags}
              data={template}
              postType={postType}
              pageUrl={pageUrl}
              lang={language}
            />

            <div className={classnames(styles.wrapContent)}>
              {content ? (
                <Content data={content} contentHead={contentHead} />
              ) : null}

              {/* TODO: отключил по запросу наташи */}
              {/* {postType === 'templateLeadGenerator' ? (
                <div className={classnames(styles.additionalPostLink)}>
                  <h5 className={classnames('scr-h5')}>
                    {resourceCenterPostInfoTrialTitle}
                    <a
                      href={resourceCenterPostInfoTrialUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classnames('scr-link scr-blue')}
                    >
                      {resourceCenterPostInfoTrialMarketedText}
                    </a>
                  </h5>
                </div>
              ) : null} */}

              {postType === 'templateInnerPost' && content ? (
                <div className={classnames(styles.postInfo)}>
                  <Rating databaseId={databaseId} />
                  <Share url={slug} title={title} tags={tags} uri={props.uri} />
                </div>
              ) : null}
            </div>

            <div>
              {/* TODO: включить после реализации функционала рассылки */}
              {/* <div className={classnames(styles.formWrap, 'scr-wrap')}>
                <Subscribe
                  customData={postType === 'templateLeadGenerator' ? subscribeData : {}}
                />
              </div> */}

              {templatePageInActionForm ? <ScreverInActionSec /> : null}

              {postType === 'templateInnerPost' ? (
                <MoreStoriesSec
                  tag={currentPostСategory}
                  id={id}
                  title={'You May Be Interested'}
                  allPosts={moreStories}
                  reading={true}
                  additionalLink={additionalLink}
                />
              ) : null}
            </div>
          </div>
        </>
      )}
    </Layout>
  );
};

export default TemplatePost;
